<script lang="ts">
	import { page } from '$app/stores';
	import { setContext } from 'svelte';
	import ErrorDialog from '$lib/components/UI/ErrorDialog.svelte';
	import { createErrorStore } from '$lib/stores/errorStore.js';
	import '../app.css';
	import '../main.css';
	import { t } from '$lib/translations';
	import { PUBLIC_PATIENT_WEB_URL } from '$env/static/public';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
	let dialog: HTMLDialogElement | undefined = $state();

	const errorStore = createErrorStore(null);
	setContext('error', errorStore);

	function preventDefault(event: Event) {
		event.preventDefault();
	}
</script>

<svelte:head>
	<meta name="description" content={$t('common.head.description')} />
	<meta name="keywords" content="healthcare, medical, startup, health, manifesto" />
	<meta name="author" content="Riva" />
	<meta property="og:title" content="Riva | {$t('common.head.baseline')}" />
	<meta property="og:description" content={$t('common.head.description')} />
	<meta property="og:image" content={$page.url.origin + '/og-image.png'} />
	<link rel="prefetch" href={PUBLIC_PATIENT_WEB_URL} />
	<title>{$t('common.head.baseline')}</title>
</svelte:head>

<ErrorDialog />
{@render children?.()}

<!-- svelte-ignore a11y_no_noninteractive_element_to_interactive_role -->
<dialog
	id="profileDialog"
	role="button"
	bind:this={dialog}
	onmousedown={(e) => {
		if (e.target === dialog) {
			dialog.close();
			document.body.removeEventListener('touchmove', preventDefault);
			document.body.style.overflow = 'auto';
		}
	}}
></dialog>

<style>
	dialog {
		border-radius: 0.2em;
		border: none;
		outline: none;
		padding: 0;
		border-radius: 1rem;
		max-width: 650px;
		width: 90%;
		box-shadow: 0 30px 50px -25px rgba(30, 0, 0, 0.25);
	}
</style>
